import { createContext, useContext } from 'react';
export const POPOVER_PADDINGS = ['sm', 'md', 'lg'];
export const POPOVER_TRIGGER_TYPE = ['click', 'hover'];
export const PopoverContext = createContext(undefined);
export const usePopover = () => {
    const context = useContext(PopoverContext);
    if (context === undefined) {
        throw new Error('usePopover must be used within a PopoverProvider');
    }
    return context;
};
//# sourceMappingURL=PopoverContext.js.map